import Navbar from "./Navbar";
import Footer from "./Footer";
import SalesAssistant from "./SalesAssistant";
import MobileScanBar from "./MobileScanBar";

export default function Layout({ children, assistantContext }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 pb-[68px] lg:pb-0">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <SalesAssistant context={assistantContext} />
      <MobileScanBar />
    </div>
  );
}
